import React from "react";
import HomePage from "../pages/home";

const Home = () => {
    return (
        <HomePage />
    )
};

export default Home;
